import React, { useCallback,useEffect } from "react"
import { siteUrl } from "../../../shared/utils/siteUrl"
import { useStaticQuery, graphql } from "gatsby"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import Slider from "react-slick"
import Button from "../../../shared/components/atoms/button/button"
import StateUserModal from "../../../shared/components/modals/state-user-modal/state-user-modal"
import ModalPlayer from "./../modal-player/modal-player"
import imgCel from "./../../../assets/images/img-phone.svg"
import imgHowRegister from "./../../../assets/images/how-register.jpg"

import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./register.scss"

const Register = props => {
  const result = useStaticQuery(
    graphql`
      query Query {
        allContentfulNolRegistro {
          nodes {
            node_locale
            redireccionRegistro
            redireccionInicioDeSesion
            redireccionEstadoDeRegistro
            beneficiosDeRegistro {
              descripcionBeneficio {
                json
              }
              imagenBeneficio {
                description
                file {
                  url
                }
              }
            }
          }
        }
      }
    `
  )
  useEffect(() => {
    localStorage.setItem("PREV_PARAMS", window.location?.search)  
  }, [])
  
  const loginRedirect = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "Interacciones - Accede a tu cuenta",
      category: "cole challenge",
      action: "click",
      label: "iniciar sesion",
    })
    window.location.href = siteUrl + "/login"
  }

  const copieLogin =
    process.env.LOCALE === "es-PE"
      ? "y actualiza tus datos para ver lo mejor del Mundo Nosotras"
      : "para ver lo mejor del Mundo Nosotras"

  const copyNoAdult =
    process.env.LOCALE === "es-AR" ||
    process.env.LOCALE === "es-PY" ||
    process.env.LOCALE === "es-UY"
      ? "Si sos menor de edad y querés conocer cuál es el estado de tu registro:"
      : "Si eres menor de edad y quieres conocer cuál es el estado de tu registro:"

  const handleOpenModalVideo = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "Interacciones - Video",
      category: "cole challenge",
      action: "click",
      label: "imagen",
    })
    props.setModal(
      <ModalPlayer
        src="https://www.youtube.com/embed/JZb-gFfmmq0"
        setModal={props.setModal}
      />
    )
  }

  const itemsContentRegister = useCallback(() => {
    const elements = [
      ...result.allContentfulNolRegistro.nodes
        .filter(e => e.node_locale === process.env.LOCALE)[0]
        .beneficiosDeRegistro.map((info, index) => (
          <div className="f-register-benefits-item" key={index}>
            <img
              alt={info.imagenBeneficio.description}
              src={info.imagenBeneficio.file.url}
            />
            {documentToReactComponents(info.descripcionBeneficio.json)}
          </div>
        )),
      <button
        className="f-register-benefits-item f-register-benefits-item--btn "
        key="video-register"
        onClick={handleOpenModalVideo}
      >
        <div className="video-thumb" >
          <img src={imgHowRegister} alt="Miniatura de video" />
        </div>
        <p>Conoce más, sobre el proceso de registro</p>
      </button>,
    ]

    const sliderSettings = {
      centerMode: props.mobile ? true : false,
      dots: props.mobile ? true : false,
      infinite: props.mobile ? true : false,
      slidesToShow: props.mobile ? 1 : 3,
      slidesToScroll: 1,
      centerPadding: "30px",
    }

    return (
      <div className="f-register-benefits-container">
        {props.mobile ? (
          <Slider
            {...sliderSettings}
            className="f-register-benefits"
            children={elements}
          ></Slider>
        ) : (
          elements.map(i => i)
        )}
      </div>
    )
  }, [props.mobile])

  return (
    <div className="f-register">
      <div className="f-register-content">
        <div className="f-register-content-left">
          {!props.mobile && (
            <h2>
              {process.env.LOCALE === "es-AR" ||
              process.env.LOCALE === "es-PY" ||
              process.env.LOCALE === "es-UY"
                ? "Accedé a tu cuenta"
                : "Accede a tu cuenta"}
            </h2>
          )}
          {!props.mobile && <p className="f-copy-left">{copieLogin}</p>}
          {!props.mobile && <br />}

          {!props.mobile && (
            <div onClick={loginRedirect}>
              <Button className="new-dark-blue short" title="Iniciar sesión" />
            </div>
          )}
          <div className="f-register-content-left-boxPurple">
            <p>
              {copyNoAdult}
              <br />{" "}
              <span
                className="f-register-clic-status"
                onClick={() => {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: "Interacciones - Accede a tu cuenta",
                    category: "cole challenge",
                    action: "click",
                    label: "iniciar sesion",
                  })
                  props.setModal(
                    <StateUserModal setModalActive={props.setModal} />
                  )
                }}
              >
                {process.env.LOCALE === "es-AR" ||
                process.env.LOCALE === "es-PY" ||
                process.env.LOCALE === "es-UY"
                  ? "hacé click acá"
                  : "hazlo aquí"}
              </span>
            </p>
          </div>
        </div>
        <div className="f-register-content-right">
          <h1>
            {process.env.LOCALE === "es-AR" ||
            process.env.LOCALE === "es-PY" ||
            process.env.LOCALE === "es-UY"
              ? "¿Sos nueva acá?"
              : "¿Eres nueva aquí?"}
          </h1>
          <h2 className="f-no-mobile">
            {process.env.LOCALE === "es-AR" ||
            process.env.LOCALE === "es-PY" ||
            process.env.LOCALE === "es-UY"
              ? "REGISTRATE"
              : "REGÍSTRATE"}
          </h2>
          <br className="f-in-mobile"></br>
          <a
            href={
              result.allContentfulNolRegistro.nodes.filter(
                e => e.node_locale === process.env.LOCALE
              )[0].redireccionRegistro
            }
            className="f-in-mobile"
          >
            <Button
              className="new-dark-blue short"
              title={
                process.env.LOCALE === "es-AR" ||
                process.env.LOCALE === "es-PY" ||
                process.env.LOCALE === "es-UY"
                  ? "Registrate"
                  : "Regístrate"
              }
            />
          </a>
          {itemsContentRegister()}
          <a
            href={
              result.allContentfulNolRegistro.nodes.filter(
                e => e.node_locale === process.env.LOCALE
              )[0].redireccionRegistro
            }
            className="f-no-mobile"
            onClick={() => {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: "Interacciones - Comenzar Registro",
                category: "cole challenge",
                action: "click",
                label: 'comenzar',
              })
            }}
          >
            <Button className="new-dark-blue short" title="¡Comenzar!" />
          </a>
        </div>
      </div>
    </div>
  )
}

export default Register
